/* eslint-disable class-methods-use-this */
import Coach from './Coach';

export default class User extends Coach {
    static get RolesMap() {
        return {
            ROLE_COACH: 'Coach',
            ROLE_SOLUTIONS: 'Solutions',
            ROLE_ASSESSMENTS: 'MyAssessment',
            ROLE_CUSTOMERS: 'MyCustomer',
            ROLE_ADMIN: 'Administrator',
        };
    }

    static get LanguagesMap() {
        return {
            de: 'Deutsch',
            en: 'Englisch',
            fr: 'Französisch',
            it: 'Italienisch',
        };
    }

    // noinspection JSMethodCanBeStatic
    resource() {
        return 'users';
    }

    static getAdminList() {
        return User.get();
    }

    get isAdmin() {
        return this.roles.includes('ROLE_ADMIN');
    }

    hasRole(role) {
        return this.isAdmin || this.roles.includes(role);
    }

    hasAnyRoles(roles) {
        if (this.isAdmin) {
            return true;
        }

        return this.roles.filter(v => roles.includes(v)).length > 0;
    }
}
